import Content from '@/layout/content';
import Layout from '@/layout';

export default {
  path: '/drone',
  component: window.name ? Content : Layout,
  redirect: '/drone/index',
  meta: {
    title: '无人机',
    icon: 'iconfont icon-shexiangtou',
    code: '010216'
  },
  children: [
    {
      path: 'index',
      name: 'drone',
      component: () => import('@/views/droneSystem/index'),
      meta: {
        activeMenu: '/drone',
        noPadding: true
      },
      children: [
        {
          path: 'real-data',
          name: 'drone-real-data',
          component: () => import('@/views/droneSystem/real-data/index.vue'),
          meta: {
            activeMenu: '/drone',
            noPadding: true
          }
        },
        {
          path: 'history-data',
          name: 'drone-history-data',
          component: () => import('@/views/droneSystem/history-data/index.vue'),
          meta: {
            activeMenu: '/drone',
            noPadding: true
          }
        },
        {
          path: 'alarm-data',
          name: 'drone-alarm-data',
          component: () => import('@/views/droneSystem/alarm-data/index.vue'),
          meta: {
            activeMenu: '/drone',
            noPadding: true
          }
        },
        {
          path: 'task-data',
          name: 'drone-task-data',
          component: () => import('@/views/droneSystem/task-data/index.vue'),
          meta: {
            activeMenu: '/drone',
            noPadding: true
          }
        }
      ]
    },
    {
      path: 'history-trajectory',
      name: 'history-trajectory',
      component: () => import('@/views/droneSystem/history-trajectory.vue'),
      meta: {
        activeMenu: '/drone',
        noPadding: true
      }
    },

    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
